import { useMemo } from 'react';

import { getFullAddress } from 'lib/helpers/utility';
import { useStates } from 'lib/hooks/queries/states/useStates';

export const useDocumentPractice = ({ practice, enabled }) => {
  const { data: statesData } = useStates({ options: { enabled } });

  return useMemo(() => {
    if (!practice) return practice;

    const record = practice.practiceAddress;
    const resolved =
      typeof record === 'string'
        ? record.replace(/\s+/g, ' ').trim()
        : getFullAddress({ address: record, states: statesData?.states });

    const address = practice.address || resolved || '';

    return address ? { ...practice, address } : practice;
  }, [practice, statesData?.states]);
};
